<template>
  <PflegeExpansionPanel
    v-editable="props.blok"
    :heading="props.blok.heading"
    :heading-tag="props.blok.headingTag"
    :data-uid="props.blok._uid"
  >
    <RichtextResolver v-if="willRender(props.blok.content)" :blok="props.blok.content" />
  </PflegeExpansionPanel>
</template>

<script lang="ts" setup>
import { PflegeExpansionPanel } from '@webcarelbj/shared-components'
import { BlokProps, BlokText } from '../../types/blok'
import { RichtextResolver } from '../'
import { willRender } from '../../utils'
import { DocContent } from '../../types/richtext'

export interface ExpansionPanelBlok extends BlokText {
  content: DocContent
}

const props = defineProps<BlokProps<ExpansionPanelBlok>>()
</script>
